const UNIT_LABELS: Record<string, string> = {
  kg: 'кг',
  g: 'г',
  gr: 'г',
  l: 'л',
  ml: 'мл',
  pcs: 'шт',
  pc: 'шт',
  piece: 'шт',
  'шт.': 'шт',
}

export const formatUnitLabel = (unit: string | null | undefined): string => {
  const raw = unit?.trim() ?? ''
  if (!raw) {
    return 'кг'
  }
  const mapped = UNIT_LABELS[raw.toLowerCase()]
  return mapped ?? raw
}
